import { render, staticRenderFns } from "./ProductOffers.vue?vue&type=template&id=0185de06&"
import script from "./ProductOffers.vue?vue&type=script&lang=js&"
export * from "./ProductOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports